module.exports = __webpack_public_path__ + "img/hall_1.778af169.jpg";